import { combineReducers } from "redux";
import language from "./modules/language";
import modal from "./modules/modal/modal";
import theme from "./modules/theme";
import login from "./modules/auth/checkLoginSlice";
import auth from "./modules/auth/authSlice";
import otp from "./modules/auth/otpSlice";
import activeSegment from "./modules/activeSegment/activeSegment";
import userServices from "./modules/subService/userServices";
import activeSubService from "./modules/subService/activeSubService";
import drawer from "./modules/drawer/drawer";
import incognito from "./modules/incognito/incognito";
import realtime from "./modules/ai/realtime/realtimeSlice";
import bottomDrawer from "./modules/bottomDrawer/bottomDrawer";
import segmentAnswers from "./modules/segmentAnswers/segmentAnswers";
import uploadedFiles from "./modules/files/uploadedFiles/uploadedFiles";
import validationData from "./modules/validationData/validationData";
import subServiceChats from "./modules/subService/subServiceChats";
import discountCode from "./modules/discountCode/discountCode";
import streamedChat from "./modules/streamedChat/streamedChat";
import aiModels from "./modules/aiModels/aiModels";
import answeredQuestions from "./modules/answeredQuestions/answeredQuestions";
import toast from "./modules/toast/toast";
import seenNotification from "./modules/seenNotification/seenNotification";
import referralCode from "./modules/auth/referralCode";
import { checkLoginReducer } from "./modules/auth/checkLogin";
import { getOtpCodeReducer } from "./modules/auth/getOtpCode";
import { verifyOtpReducer } from "./modules/auth/verifyOtp";
import { getCategoryListReducer } from "./modules/ai/getCategoryList/getCategoryList";
import { getCategoryServicesReducer } from "./modules/ai/getCategoryServices/getCategoryServices";
import { getServiceSegmentsReducer } from "./modules/ai/getServiceSegments/getServiceSegments";
import { getServicePurchaseModelsReducer } from "./modules/ai/getServicePurchaseModels/getServicePurchaseModels";
import { serviceFileValidationReducer } from "./modules/ai/serviceFileValidation/serviceFileValidation";
import { getUserSubServicesReducer } from "./modules/ai/getUserSubServices/getUserSubServices";
import { getUserChatsReducer } from "./modules/ai/getUserChats/getUserChats";
import { choosePurchaseModelReducer } from "./modules/ai/choosePurchaseModel/choosePurchaseModel";
import { postUserServiceChatReducer } from "./modules/ai/postUserServiceChat/postUserServiceChat";
import { postUserServiceEntryReducer } from "./modules/ai/postUserServiceEntry/postUserServiceEntry";
import { buySubServiceReducer } from "./modules/ai/buySubService/buySubService";
import { postUserUploadFileReducer } from "./modules/ai/postUserUploadFile/postUserUploadFile";
import { getResultModalDataReducer } from "./modules/ai/getResultModalData/getResultModalData";
import { createUserServiceReducer } from "./modules/ai/postCreateUserService/postCreateUserService";
import { shareReducer } from "./modules/ai/share/share";
import { getSubscriptionPlansReducer } from "./modules/ai/getSubscriptionPlans/getSubscriptionPlans";
import { buySubscriptionPlanReducer } from "./modules/ai/buySubscriptionPlan/buySubscriptionPlan";
import { specialistProfileReducer } from "./modules/specialistProfile/specialistProfile";
import { getUserHistoryReducer } from "./modules/ai/getUserHistory/getUserHistory";
import { buySubServicesReducer } from "./modules/ai/buySubServices/buySubServices";
import { thirdPartyCreateUserServiceReducer } from "./modules/ai/postThirdPartyCreateUserService/postThirdPartyCreateUserService";
import { postThirdPartyUserServiceChatReducer } from "./modules/ai/postThirdPartyUserServiceChat/postThirdPartyUserServiceChat";
import { getThirdPartyUserSubServicesHistoryReducer } from "./modules/ai/getThirdPartyUserSubServicesHistory/getThirdPartyUserSubServicesHistory";
import { getThirdPartyChatsReducer } from "./modules/ai/getThirdPartyChats/getThirdPartyChats";
import { checkDiscountReducer } from "./modules/ai/checkDiscount/checkDiscount";
import { deleteUserSubServiceReducer } from "./modules/ai/deleteUserSubService/deleteUserSubService";
import { userSubServiceFilesReducer } from "./modules/ai/postUserSubServiceFiles/postUserSubServiceFiles";
import { getProfileReducer } from "./modules/ai/getProfile/getProfile";
import { profileUpdateReducer } from "./modules/ai/profileUpdate/profileUpdate";
import { userLogoutReducer } from "./modules/ai/userLogout/userLogout";
import { getUserTransactionsReducer } from "./modules/ai/getUserTransactions/getUserTransactions";
import { walletCashInReducer } from "./modules/ai/walletCashIn/walletCashIn";
import { getUserNotificationsReducer } from "./modules/ai/getUserNotifications/getUserNotifications";
import { seenAnnouncedNotificationReducer } from "./modules/ai/postSeenAnnouncedNotification/postSeenAnnouncedNotification";
import { authGoogleReducer } from "./modules/auth/authGoogle";
import { authGoogleCredentialReducer } from "./modules/auth/authGoogleCredential";
import { fcmTokenReducer } from "./modules/fcmToken/fcmToken";
import { getTokensMultiplierRatioReducer } from "./modules/ai/getTokensMultiplierRatio/getTokensMultiplierRatio";
import { getUserPersonalizationReducer } from "./modules/ai/getUserPersonalization/getUserPersonalization";
import { postUserPersonalizationReducer } from "./modules/ai/postUserPersonalization/postUserPersonalization";
import { getExtraTokenShowReducer } from "./modules/ai/getExtraTokenShow/getExtraTokenShow";
import { postExtraTokenShowReducer } from "./modules/ai/postExtraTokenShow/postExtraTokenShow";
import { getUserTokenHistoryReducer } from "./modules/ai/getUserTokenHistory/getUserTokenHistory";
import { getSubscriptionHistoryReducer } from "./modules/ai/getSubscriptionHistory/getSubscriptionHistory";
import { getAnnouncedNotificationsReducer } from "./modules/ai/announcedNotifications/announcedNotifications";
import { postReferralCodeReducer } from "./modules/ai/postReferralCode/postReferralCode";
import { getClientIdentifiersReducer } from "./modules/getClientIdentifiers/getClientIdentifiers";
import selectedFileType from "./modules/selectedFileType/selectedFileType";
import {getTextToSpeechReducer} from "./modules/ai/getTextToSpeech/getTextToSpeech";
import {postFeedbackReducer} from "./modules/ai/postFeedback/postFeedback";
import {getFeedbacksReducer} from "./modules/ai/getFeedbacks/getFeedbacks";
import {showBotsReducer} from "./modules/bots/showBots/showBots";
import {agencyCreateUserServiceReducer} from "./modules/bots/postAgencyCreateUserService/postAgencyCreateUserService";
import {agencyListReducer} from "./modules/bots/agencyList/agencyList";
import {createAgencyReducer} from "./modules/bots/createAgency/createAgency";
import {checkAgencyUsernameReducer} from "./modules/bots/checkAgencyUsername/checkAgencyUsername";
import {createRealtimeSessionReducer} from "./modules/ai/createRealtimeSession/createRealtimeSession";
import {getRealTimeChatReducer} from "./modules/ai/getRealTimeChat/getRealTimeChat";
import { updateAgencyReducer } from "./modules/bots/updateAgency/updateAgency";
import { updateAvatarReducer } from "./modules/bots/updateAvatar/updateAvatar";
import { agencyRawDataListReducer } from "./modules/bots/agencyRawDataList/agencyRawDataList";
import { agencyRawDataStoreReducer } from "./modules/bots/agencyRawDataStore/agencyRawDataStore";
import { agencyRawDataDeleteReducer } from "./modules/bots/agencyRawDataDelete/agencyRawDataDelete";

export const RootReducer = combineReducers({
  language,
  modal,
  theme,
  login,
  auth,
  otp,
  activeSegment,
  userServices,
  activeSubService,
  drawer,
  incognito,
  realtime,
  bottomDrawer,
  segmentAnswers,
  uploadedFiles,
  validationData,
  subServiceChats,
  discountCode,
  streamedChat,
  aiModels,
  answeredQuestions,
  toast,
  seenNotification,
  referralCode,
  selectedFileType,
  checkLogin: checkLoginReducer,
  getOtpCode: getOtpCodeReducer,
  verifyOtp: verifyOtpReducer,
  getCategoryList: getCategoryListReducer,
  getCategoryServices: getCategoryServicesReducer,
  getServiceSegments: getServiceSegmentsReducer,
  getServicePurchaseModels: getServicePurchaseModelsReducer,
  serviceFileValidation: serviceFileValidationReducer,
  getUserSubServices: getUserSubServicesReducer,
  getUserChats: getUserChatsReducer,
  choosePurchaseModel: choosePurchaseModelReducer,
  postUserServiceChat: postUserServiceChatReducer,
  postUserServiceEntry: postUserServiceEntryReducer,
  buySubService: buySubServiceReducer,
  postUserUploadFile: postUserUploadFileReducer,
  share: shareReducer,
  getResultModalData: getResultModalDataReducer,
  createUserService: createUserServiceReducer,
  specialistProfile: specialistProfileReducer,
  getSubscriptionPlans: getSubscriptionPlansReducer,
  buySubscriptionPlan: buySubscriptionPlanReducer,
  getUserHistory: getUserHistoryReducer,
  buySubServices: buySubServicesReducer,
  thirdPartyCreateUserService: thirdPartyCreateUserServiceReducer,
  postThirdPartyUserServiceChat: postThirdPartyUserServiceChatReducer,
  getThirdPartyUserSubServicesHistory: getThirdPartyUserSubServicesHistoryReducer,
  getThirdPartyChats: getThirdPartyChatsReducer,
  checkDiscount: checkDiscountReducer,
  deleteUserSubService: deleteUserSubServiceReducer,
  userSubServiceFiles: userSubServiceFilesReducer,
  getProfile: getProfileReducer,
  profileUpdate: profileUpdateReducer,
  userLogout: userLogoutReducer,
  deleteUserSessionFiles: deleteUserSubServiceReducer,
  walletCashIn: walletCashInReducer,
  getUserTransactions: getUserTransactionsReducer,
  getUserNotifications: getUserNotificationsReducer,
  seenAnnouncedNotification: seenAnnouncedNotificationReducer,
  authGoogle: authGoogleReducer,
  authGoogleCredential: authGoogleCredentialReducer,
  fcmToken: fcmTokenReducer,
  getTokensMultiplierRatio: getTokensMultiplierRatioReducer,
  getUserPersonalization: getUserPersonalizationReducer,
  postUserPersonalization: postUserPersonalizationReducer,
  getExtraTokenShow: getExtraTokenShowReducer,
  postExtraTokenShow: postExtraTokenShowReducer,
  getUserTokenHistory: getUserTokenHistoryReducer,
  getSubscriptionHistory: getSubscriptionHistoryReducer,
  getAnnouncedNotifications: getAnnouncedNotificationsReducer,
  postReferralCode: postReferralCodeReducer,
  getClientIdentifiers: getClientIdentifiersReducer,
  getTextToSpeech: getTextToSpeechReducer,
  postFeedback: postFeedbackReducer,
  getFeedbacks: getFeedbacksReducer,
  showBots: showBotsReducer,
  agencyCreateUserService: agencyCreateUserServiceReducer,
  agencyList: agencyListReducer,
  createAgency: createAgencyReducer,
  checkAgencyUsername: checkAgencyUsernameReducer,
  createRealtimeSession: createRealtimeSessionReducer,
  getRealTimeChat: getRealTimeChatReducer,
  updateAgency: updateAgencyReducer,
  updateAvatar: updateAvatarReducer,
  agencyRawDataList: agencyRawDataListReducer,
  agencyRawDataStore: agencyRawDataStoreReducer,
  agencyRawDataDelete: agencyRawDataDeleteReducer,
});
